<template>
  <div class="container-fluid">
    <table class="xz-table">
      <thead>
      <tr>
        <th class="bold">Betalingsmiddel</th>
        <th class="bold">Antall</th>
        <th class="bold"></th>
        <th class="bold">Beløp</th>
      </tr>
      </thead>
      <tbody>

      <tr>
        <td colSpan="4"><b>Kontant</b></td>
      </tr>
      <tr>
        <td>Total kontant</td>
        <td>{{ cashTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(cashPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td colSpan="4"><b>Kredittkort</b></td>
      </tr>
      <tr>
        <td>Total kredittkort</td>
        <td>{{ cardTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(cardPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td colSpan="4"><b>BankAxept</b></td>
      </tr>
      <tr>
        <td>Total BankAxept</td>
        <td>{{ bankAxeptTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(bankAxeptPaymentsTotalAmount) }}</td>
      </tr>

      <tr v-if="loyaltyPointsCount > 0 || loyaltyPointsPaymentsTotalAmount > 0">
        <td colSpan="4"><b>Bonuspoeng</b></td>
      </tr>
      <tr v-if="loyaltyPointsCount > 0 || loyaltyPointsPaymentsTotalAmount > 0">
        <td>Total bonuspoeng</td>
        <td>{{ loyaltyPointsCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(loyaltyPointsPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td class="bold">Total salg</td>
        <td class="bold">{{ totalPaymentsCount }}</td>
        <td></td>
        <td class="bold">{{ displayTwoDecimals(totalPayments) }}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
  import MathUtil from "@/util/MathUtil";

  export default {
    props: {
      xReportCounters: Object,
      vat: Object
    },
    computed: {
      cashTotalCount() {
        let cashPickupCount = this.xReportCounters.cashPickupCount;
        let cashDineInCount = this.xReportCounters.cashDineInCount;
        let cashDeliveryCount = this.xReportCounters.cashDeliveryCount;
        return (cashPickupCount + cashDineInCount + cashDeliveryCount);
      },

      bankAxeptTotalCount() {
        let bankAxeptPickupCount = this.xReportCounters.bankAxeptPickupCount;
        let bankAxeptDineInCount = this.xReportCounters.bankAxeptDineInCount;
        let bankAxeptDeliveryCount = this.xReportCounters.bankAxeptDeliveryCount;
        return (bankAxeptPickupCount + bankAxeptDineInCount + bankAxeptDeliveryCount);
      },

      cardTotalCount() {
        let cardPickupCount = this.xReportCounters.cardPickupCount;
        let cardDineInCount = this.xReportCounters.cardDineInCount;
        let cardDeliveryCount = this.xReportCounters.cardDeliveryCount;
        return (cardPickupCount + cardDineInCount + cardDeliveryCount);
      },

      cashPickupPaymentsTotalAmount() {
        let cashPickupPaymentsTotalAmount = this.xReportCounters.cashPickupPaymentsTotalAmount ? this.xReportCounters.cashPickupPaymentsTotalAmount : 0;
        return cashPickupPaymentsTotalAmount;
      },

      cashDineInPaymentsTotalAmount(){
        let cashDineInPaymentsTotalAmount = this.xReportCounters.cashDineInPaymentsTotalAmount ? this.xReportCounters.cashDineInPaymentsTotalAmount : 0;
        return cashDineInPaymentsTotalAmount;
      },

      cashDeliveryPaymentsTotalAmount(){
        let cashDeliveryPaymentsTotalAmount = this.xReportCounters.cashDeliveryPaymentsTotalAmount ? this.xReportCounters.cashDeliveryPaymentsTotalAmount : 0;
        return cashDeliveryPaymentsTotalAmount;
      },

      cashPaymentsTotalAmount() {
        return this.cashPickupPaymentsTotalAmount + this.cashDineInPaymentsTotalAmount + this.cashDeliveryPaymentsTotalAmount;
      },

      bankAxeptPaymentsTotalAmount() {
        let bankAxeptDeliveryPaymentsTotalAmount = this.xReportCounters.bankAxeptDeliveryPaymentsTotalAmount ? this.xReportCounters.bankAxeptDeliveryPaymentsTotalAmount : 0;
        return this.xReportCounters.bankAxeptPickupPaymentsTotalAmount + this.xReportCounters.bankAxeptDineInPaymentsTotalAmount + bankAxeptDeliveryPaymentsTotalAmount;
      },

      cardPaymentsTotalAmount() {
        return this.xReportCounters.cardPickupPaymentsTotalAmount + this.xReportCounters.cardDineInPaymentsTotalAmount + this.xReportCounters.cardDeliveryPaymentsTotalAmount;
      },

      loyaltyPointsCount() {
        return this.xReportCounters.loyaltyPointsCount ? this.xReportCounters.loyaltyPointsCount : 0;
      },

      loyaltyPointsPaymentsTotalAmount() {
        return this.xReportCounters.loyaltyPointsPaymentsTotalAmount ? this.xReportCounters.loyaltyPointsPaymentsTotalAmount : 0;
      },

      totalPaymentsCount() {
        return this.bankAxeptTotalCount + this.cardTotalCount + this.cashTotalCount + this.loyaltyPointsCount;
      },
      totalPayments() {
        return (this.xReportCounters.bankAxeptPickupPaymentsTotalAmount + this.xReportCounters.bankAxeptDineInPaymentsTotalAmount + this.xReportCounters.bankAxeptDeliveryPaymentsTotalAmount
            + this.xReportCounters.cardPickupPaymentsTotalAmount + this.xReportCounters.cardDineInPaymentsTotalAmount + this.xReportCounters.cardDeliveryPaymentsTotalAmount
            + this.cashPickupPaymentsTotalAmount + this.cashDineInPaymentsTotalAmount + this.cashDeliveryPaymentsTotalAmount
            + this.loyaltyPointsPaymentsTotalAmount);
      }
    },
    methods: {
      displayTwoDecimals(num){
        if(num > 0 || num < 0){
          return MathUtil.displayTwoDecimals(num);
        }else {
          return num;
        }
      }
    }
  }
</script>
